

export function getRuthu(input) {
    let output = "";
    if (input === "சித்திரை") {
        output = "மேஷம் மாதம் - வசந்த ருது";
    } else if (input === "வைகாசி") {
        output = "ரிஷபம் மாதம் - வசந்த ருது";
    } else if (input === "ஆனி") {
        output = "மிதுனம் மாதம் - கிரீஷ்ம ருது";
    } else if (input === "ஆடி") {
        output = "கடகம் மாதம் - கிரீஷ்ம ருது";
    } else if (input === "ஆவணி") {
        output = "சிம்மம் மாதம் - வருஷ ருது";
    } else if (input === "புரட்டாசி") {
        output = "கன்னி மாதம் - வருஷ ருது";
    } else if (input === "ஐப்பசி") {
        output = "துலாம் மாதம் - சரத் ருது";
    } else if (input === "கார்த்திகை") {
        output = "விருச்சிகம் மாதம் - சரத் ருது";
    } else if (input === "மார்கழி") {
        output = "தனுசு மாதம் - ஹேமந்த ருது";
    } else if (input === "தை") {
        output = "மகரம் மாதம் - ஹேமந்த ருது";
    } else if (input === "மாசி") {
        output = "கும்பம் மாதம் - வசந்த ருது";
    } else if (input === "பங்குனி") {
        output = "மீனம் மாதம் - சிசிர ருது";
    }
    return output;
}

export function getSoolam(input) {
    let output = "";
    if (input === "1") {
        output = "கிழக்கு";
    } else if (input === "2") {
        output = "மேற்கு";
    } else if (input === "3") {
        output = "தெற்கு";
    } else if (input === "4") {
        output = "வடக்கு";
    }
    return output
}

export function getParikaram(input) {
    let output = "";
    if (input === "1") {
        output = "வெல்லம்";
    } else if (input === "2") {
        output = "தயிர்";
    } else if (input === "3") {
        output = "பால்";
    } else if (input === "4") {
        output = "தைலம்";
    }
    return output
}
